import React, { Component, Fragment } from 'react';
import FormInputNumber from '../_shared/forms/FormInputNumber';
import FormInputText from '../_shared/forms/FormInputText';

class JobExtras extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let extras = this.props.extras;

        if (this.props.dtn) {
            let providerExtraType = this.props.extrasType === 'selectedExtras' ? 'job_extras' : '';

            extras = this.props.extras.map((extra) => {
                let extraWithPrice = this.props.extrasPrices.find((extraPrice) => {
                    return extraPrice.id === extra.id;
                });

                extra.price = extraWithPrice?.price ? extraWithPrice.price : extraWithPrice?.default_price || 0;

                let providerExtraWithPrice = this.props.serviceProvider[this.props.providerExtrasType].find(
                    (providerExtra) => {
                        return providerExtra.id === extra.value;
                    }
                );

                if (typeof providerExtraWithPrice !== 'undefined') {
                    extra.providerPrice = providerExtraWithPrice.pivot.price;
                } else {
                    extra.providerPrice = extra.provider_default_price ? extra.provider_default_price * 100 : 0;
                }

                return extra;
            });
        }

        return extras.map((extra) => (
            <div key={extra.value}>
                <hr />
                <div className="row">
                    <div className="col-md-4">
                        <label>NAME</label>
                        <input type="text" className="form-control" value={extra.label} disabled />
                    </div>
                    {!this.props.hideFields && (
                        <div className="col-md-4">
                            <FormInputNumber
                                type="number"
                                label={!this.props.isAdmin ? 'Customer Quantity' : 'Quantity'}
                                step="1"
                                min="1"
                                classes={'form-control'}
                                name="quantity"
                                value={extra.quantity || 1}
                                handleChange={(e) =>
                                    this.props.onExtraQtyChange(e, extra, this.props.extrasType, 'quantity')
                                }
                                handleDisabled={extra.singular}
                            />
                            <div className="row">
                                {this.props.dtn ? (
                                    <div className="col-md-6">
                                        <p>Item price: &pound;{(extra.price / 100).toFixed(2)}</p>
                                    </div>
                                ) : (
                                    ''
                                )}
                                {this.props.dtn ? (
                                    <div className="col-md-6 ">
                                        {extra.total_weight &&
                                        typeof extra.total_weight !== 'undefined' &&
                                        parseInt(extra.total_weight) !== 0 ? (
                                            <p>
                                                Total price: &pound;
                                                {(
                                                    (extra.price * (parseFloat(extra.total_weight) || 1.0)) /
                                                    100
                                                ).toFixed(2)}
                                            </p>
                                        ) : (
                                            <p>
                                                Total price: &pound;
                                                {((extra.price * (parseFloat(extra.quantity) || 1.0)) / 100).toFixed(2)}
                                            </p>
                                        )}
                                    </div>
                                ) : (
                                    ''
                                )}
                            </div>
                        </div>
                    )}
                    {this.props.dtn ? (
                        <div className="col-md-4">
                            <FormInputNumber
                                type="number"
                                label="Provider quantity"
                                step="1"
                                min="0"
                                classes={'form-control'}
                                name="provider_quantity"
                                value={extra.provider_quantity || 0}
                                handleChange={(e) =>
                                    this.props.onExtraQtyChange(e, extra, this.props.extrasType, 'provider_quantity')
                                }
                                handleDisabled={extra.singular}
                            />
                            <div className="row">
                                {this.props.dtn ? (
                                    <div className="col-md-6">
                                        <p>Item price: &pound;{(extra.providerPrice / 100).toFixed(2)}</p>
                                    </div>
                                ) : (
                                    ''
                                )}
                                {this.props.dtn ? (
                                    <div className="col-md-6 ">
                                        {extra.provider_total_weight &&
                                        typeof extra.provider_total_weight !== 'undefined' &&
                                        parseInt(extra.provider_total_weight) !== 0 ? (
                                            <p>
                                                Total price: &pound;
                                                {(
                                                    (extra.providerPrice *
                                                        (parseFloat(extra.provider_total_weight) || 0)) /
                                                    100
                                                ).toFixed(2)}
                                            </p>
                                        ) : (
                                            <p>
                                                Total price: &pound;
                                                {(
                                                    (extra.providerPrice * (parseFloat(extra.provider_quantity) || 0)) /
                                                    100
                                                ).toFixed(2)}
                                            </p>
                                        )}
                                    </div>
                                ) : (
                                    ''
                                )}
                            </div>
                        </div>
                    ) : (
                        ''
                    )}
                    {typeof extra.total_weight !== 'undefined' &&
                    parseInt(extra.total_weight) !== 0 &&
                    (extra.name.toLowerCase() === 'agricultural truck' || extra.name.toLowerCase() === 'fork truck') ? (
                        <div className="col-md-4 ml-2">
                            <FormInputNumber
                                type="number"
                                label="Total weight"
                                step="0.01"
                                min="0"
                                classes="form-control"
                                value={extra.total_weight || 0}
                                name="total_weight"
                                handleChange={(e) =>
                                    this.props.onExtraQtyChange(e, extra, this.props.extrasType, 'total_weight')
                                }
                            />
                        </div>
                    ) : (
                        ''
                    )}

                    {typeof extra.provider_total_weight !== 'undefined' &&
                    parseInt(extra.provider_total_weight) !== 0 &&
                    (extra.name.toLowerCase() === 'agricultural truck' || extra.name.toLowerCase() === 'fork truck') ? (
                        <div className="col-md-4 ml-2">
                            <FormInputNumber
                                type="number"
                                label="Provider total weight"
                                step="0.01"
                                min="0"
                                classes="form-control"
                                value={extra.provider_total_weight || 0}
                                name="provider_total_weight"
                                handleChange={(e) =>
                                    this.props.onExtraQtyChange(
                                        e,
                                        extra,
                                        this.props.extrasType,
                                        'provider_total_weight'
                                    )
                                }
                            />
                        </div>
                    ) : (
                        ''
                    )}

                    {this.props.dtn ? <div className="col-md-2 d-flex flex-column justify-content-end"></div> : ''}
                </div>
            </div>
        ));
    }
}
export default JobExtras;
